import { instanceApi } from '@/services/ProviderService'

export default {
    getDashboardStatistic(){
        return instanceApi().get(`/api/dashboard/statistics`).then(res => res.data);
    },
    getPackByUsers() {
        return instanceApi().get(`/api/dashboard/packbyuser`).then(res => res.data);
    },
    getPickByUsers() {
        return instanceApi().get(`/api/dashboard/pickbyuser`).then(res => res.data);
    }

}
